const style = {
  theme: {
    primary: '#BDBDBD',
    secondary: '#C4AFB1',
    accent: '#BF7B7E',
    // error: '#b71c1c',
    // warning: '',
    // info: '',
    // success: '',
    text: '#707070',
    filArianeBg: '#EFE0E2',
    selectPink: '#F7F0F1',
    white: '#FCFCFE',
    actifLink: '#FF4E6A',
    headerDrawer: '#d8405d',
    textLight: '#cecece',
    label: '#a0a0a0',
    green: '#45b197',
    updatedGrey: '#C5AFB2',
    inactiveItem: '#EF5350',
    yellow: '#d4d41b',
    rose: '#f06292',
  },
}

export default style
